export function normalizeText(value?: any): string {
  if (value === null || value === undefined) return ''
  try {
    return String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  } catch (err) {
    return String(value).toLowerCase()
  }
}

export function matchesSearch(value: any, query: string): boolean {
  if (!query || !String(query).trim()) return true
  const nq = normalizeText(query).trim()
  const nv = normalizeText(value)
  return nv.includes(nq)
}
